module.exports = __webpack_public_path__ + "static/media/familybd83500a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/family.svg
// module id = 1327
// module chunks = 0